import I18N from '@leverege/i18n';
import { Dialog, Toast } from '@leverege/ui-elements';
import { LoadingView } from '@leverege/molten/views';
import { DataSources } from '@leverege/ui-attributes';
import RecovrSales from '../../util/RecovrSales';
import C from '../../views/salesFlow/Constants';
import { jsx as _jsx } from "react/jsx-runtime";
const {
  t,
  tIcon
} = I18N.ns('recovr.actions.createTripacContract.CreateTripacContractDialog');
export default function CreateTripacContractDialog(props) {
  const {
    show,
    onClose,
    targets,
    context,
    reloadData
  } = props;
  const onOkay = async () => {
    const closeLoading = LoadingView.showDialog(targets.length > 1 ? t('loadingTitlePlural') : t('loadingTitle'));
    let isVehicleWarrantyEnabledAtLocation = true;
    let isKeysWarrantyEnabledAtLocation = true;
    // confirm that the location for each sale has the correct warranties enabled before creating
    try {
      targets.forEach(sale => {
        const location = DataSources.getData({
          id: sale.data?.data?.location?.id,
          type: 'location',
          ref: context?.clientProps?.relationship?.ref
        });
        const productTypeRecovr = sale.data?.data?.productTypes?.recovr;
        const productTypeKeys = sale.data?.data?.productTypes?.recovrKeys;
        if (location?.data?.warrantySetting !== C.WARRANTY_SETTINGS.VEHICLE_WARRANTY && productTypeRecovr) {
          isVehicleWarrantyEnabledAtLocation = false;
        }
        if (location?.data?.keysWarrantySetting !== C.WARRANTY_SETTINGS.KEYS_WARRANTY && productTypeKeys) {
          isKeysWarrantyEnabledAtLocation = false;
        }
      });
      if (!isVehicleWarrantyEnabledAtLocation || !isKeysWarrantyEnabledAtLocation) {
        if (!isVehicleWarrantyEnabledAtLocation) {
          Toast.error(t('noVehicleWarranty'));
        } else {
          Toast.error(t('noKeysWarranty'));
        }
        closeLoading();
        onClose();
        return;
      }
      await RecovrSales.createTripacContract({
        sales: targets,
        reloadData
      });
    } catch (err) {
      console.error('Could not create Tripac Contract: ', err.message);
    }
    setTimeout(async () => {
      await reloadData();
    }, 500);
    closeLoading();
    onClose();
  };
  return /*#__PURE__*/_jsx(Dialog.Question, {
    show: show,
    eventData: props,
    title: t('title'),
    icon: tIcon('icon'),
    message: t('enabledMessage', {
      count: targets.length
    }),
    okay: t('confirm'),
    okayVariant: "primary",
    onCancel: onClose,
    onOkay: onOkay
  });
}